(function(){
if(window.__witsEL)return;window.__witsEL=1;

/* ---- gallery: build thumbs, scroll-snap sync ---- */
(function(){
  var g=document.getElementById('witsGallery'); if(!g) return;
  var slides=[].slice.call(g.querySelectorAll('img.el-gslide'));
  var strip=document.getElementById('witsThumbs');
  slides.forEach(function(s,i){
    var b=document.createElement('button'); if(i===0) b.className='el-active';
    var im=document.createElement('img'); im.src=s.src; im.alt='';
    b.appendChild(im); strip.appendChild(b);
    b.addEventListener('click',function(){ go(i,true); });
  });
  var thumbs=[].slice.call(strip.children);
  var gcount=document.getElementById('witsGCount');
  function setActive(i){
    thumbs.forEach(function(x,xi){ x.classList.toggle('el-active',xi===i); });
    if(gcount) gcount.textContent=(i+1)+' / '+slides.length;
    if(strip.scrollWidth>strip.clientWidth+4 && thumbs[i]){
      var b=thumbs[i]; strip.scrollTo({left:Math.max(0,b.offsetLeft-(strip.clientWidth-b.offsetWidth)/2),behavior:'smooth'});
    }
  }
  function go(i,smooth){ if(i<0)i=0; if(i>slides.length-1)i=slides.length-1; g.scrollTo({left:i*g.clientWidth,behavior:smooth?'smooth':'auto'}); setActive(i); }
  var tick=false;
  g.addEventListener('scroll',function(){ if(tick)return; tick=true; requestAnimationFrame(function(){ tick=false; setActive(Math.round(g.scrollLeft/g.clientWidth)); }); },{passive:true});
  /* swipe past the last slide -> back to the first */
  var sx=0, sy=0, atEnd=false;
  function cur(){ return Math.round(g.scrollLeft/g.clientWidth); }
  g.addEventListener('touchstart',function(e){ var t=e.touches[0]; sx=t.clientX; sy=t.clientY; atEnd=(cur()===slides.length-1); },{passive:true});
  g.addEventListener('touchend',function(e){ var t=e.changedTouches[0]; var dx=t.clientX-sx, dy=t.clientY-sy; if(atEnd && dx<-40 && Math.abs(dx)>Math.abs(dy)) go(0,true); },{passive:true});
  var wheelLock=false;
  g.addEventListener('wheel',function(e){ if(wheelLock) return; if(cur()===slides.length-1 && e.deltaX>30){ wheelLock=true; go(0,true); setTimeout(function(){wheelLock=false;},700); } },{passive:true});
})();

/* ---- UGC auto-scroll strip ---- */
(function(){
  var track=document.getElementById('ugcTrack'); if(!track) return;
  var rm=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  track.innerHTML += track.innerHTML;
  var vp=track.parentElement, cards=[].slice.call(track.children), one=0;
  function measure(){ one=cards.length? cards[cards.length/2].offsetLeft : 0; }
  requestAnimationFrame(function(){ requestAnimationFrame(measure); });
  window.addEventListener('load', measure);
  var speed=rm?0:0.4, userTs=0, down=false, sx=0, sl=0, pos=0, lastSet=-1;
  function bump(){ userTs=Date.now(); }
  ['pointerdown','touchstart','wheel'].forEach(function(e){ track.addEventListener(e,bump,{passive:true}); });
  track.addEventListener('pointerdown',function(e){ if(e.pointerType==='mouse'){ down=true; sx=e.clientX; sl=track.scrollLeft; track.classList.add('el-drag'); try{track.setPointerCapture(e.pointerId);}catch(_){} } });
  track.addEventListener('pointermove',function(e){ if(down){ track.scrollLeft=sl-(e.clientX-sx); bump(); } });
  ['pointerup','pointercancel','pointerleave'].forEach(function(e){ track.addEventListener(e,function(){ down=false; track.classList.remove('el-drag'); }); });
  function loop(){
    if(!one) measure();
    var actual=track.scrollLeft, idle=(Date.now()-userTs>1400)&&!down;
    if(idle && speed>0){
      if(lastSet<0 || Math.abs(actual-lastSet)>1.5){ pos=actual; }
      pos+=speed;
      if(one>0){ if(pos>=one){pos-=one;} else if(pos<0){pos+=one;} }
      track.scrollLeft=Math.round(pos); lastSet=track.scrollLeft;
    } else {
      pos=actual;
      if(one>0 && !down){ if(actual>=one){ track.scrollLeft=Math.round(actual-one); lastSet=track.scrollLeft; } else if(actual<0){ track.scrollLeft=Math.round(actual+one); lastSet=track.scrollLeft; } else { lastSet=-1; } }
      else { lastSet=-1; }
    }
    var vr=vp.getBoundingClientRect(), cx=vr.left+vr.width/2, thr=vr.width*0.52, i, r, d, t, sc;
    for(i=0;i<cards.length;i++){ r=cards[i].getBoundingClientRect(); d=Math.abs(r.left+r.width/2-cx); t=d/thr; if(t>1){t=1;} sc=1.12-0.3*t; cards[i].style.transform='scale('+sc.toFixed(3)+')'; cards[i].style.opacity=(1-0.4*t).toFixed(3); }
    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);
})();

/* ---- SMOOTH ACCORDIONS ----
   Height animates on the .acc-body wrapper with real measured pixels, then releases
   to auto so an open panel reflows freely. Closing a panel whose summary scrolled
   above the viewport pulls the summary back into view (block:nearest), so the page
   never appears to jump while scrolling with panels open or closing. */
(function(){
  var rm=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DUR=280;
  document.querySelectorAll('details.el-acc').forEach(function(d){
    var sum=d.querySelector('summary'), body=d.querySelector('.el-acc-body');
    if(!sum||!body) return;
    var busy=false;
    sum.addEventListener('click',function(e){
      e.preventDefault();
      if(busy) return;
      if(rm){ d.open=!d.open; d.classList.toggle('el-open',d.open); return; }
      busy=true;
      if(!d.open){
        d.open=true; d.classList.add('el-open');
        var h=body.scrollHeight;
        body.style.height='0px'; body.style.transition='height '+DUR+'ms ease';
        requestAnimationFrame(function(){ body.style.height=h+'px'; });
        setTimeout(function(){ body.style.height=''; body.style.transition=''; busy=false; },DUR+20);
      } else {
        var h0=body.scrollHeight;
        body.style.height=h0+'px'; body.style.transition='height '+DUR+'ms ease';
        requestAnimationFrame(function(){ body.style.height='0px'; });
        d.classList.remove('el-open');
        setTimeout(function(){
          d.open=false; body.style.height=''; body.style.transition=''; busy=false;
          var r=d.getBoundingClientRect();
          if(r.top<0){ d.scrollIntoView({behavior:'smooth',block:'nearest'}); }
        },DUR+20);
      }
    });
  });
})();

/* ---- scroll reveal ---- */
(function(){
  var rm=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(rm || !('IntersectionObserver' in window)) return;
  var sel='.el-sec .el-wrap > h2, .el-sec .el-wrap > p, .el-sec .el-wrap > .el-fix-row, .el-sec .el-wrap > .el-rev-grid, .el-sec .el-wrap > .el-dare-card, .el-sec .el-wrap > .el-mega, .el-sec .el-wrap > details, .el-sec .el-wrap > .el-dsep';
  var els=[].slice.call(document.querySelectorAll(sel));
  var perSec={};
  els.forEach(function(el){
    el.classList.add('el-rv');
    var sec=el.closest('.el-sec')||document.body;
    var k=sec.id||'x';
    perSec[k]=(perSec[k]||0)+1;
    el.style.transitionDelay=Math.min((perSec[k]-1)*70,280)+'ms';
  });
  var io=new IntersectionObserver(function(en){
    en.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('el-in'); io.unobserve(e.target); } });
  },{threshold:.01,rootMargin:'0px 0px -4% 0px'});
  els.forEach(function(el){ io.observe(el); });
  window.addEventListener('scroll',function(){
    if(window.scrollY+window.innerHeight>=document.body.scrollHeight-60){
      els.forEach(function(el){ el.classList.add('el-in'); });
    }
  },{passive:true});
})();

/* ---- mini review slider dots ---- */
(function(){var qs=document.getElementById('qslide'),qd=[].slice.call(document.querySelectorAll('#qdots i'));if(!qs)return;
var orig=[].slice.call(qs.children),n=orig.length;
orig.forEach(function(c){qs.appendChild(c.cloneNode(true));});
var span=0;
function measure(){var c=qs.children;span=c[n].offsetLeft-c[0].offsetLeft;}
requestAnimationFrame(measure);addEventListener('resize',measure);
var lastX=0;
qs.addEventListener('scroll',function(){
  var sl=qs.scrollLeft,dir=sl-lastX;lastX=sl;
  if(span>0){
    if(sl>=span){qs.scrollLeft=sl-span;lastX=qs.scrollLeft;}
    else if(sl<=0&&dir<0){qs.scrollLeft=sl+span;lastX=qs.scrollLeft;}
  }
  var i=Math.round(qs.scrollLeft/310)%n;if(i<0)i+=n;
  qd.forEach(function(d,j){d.classList.toggle('el-on',j===i)});
},{passive:true});
function step(dx){
  if(span>0){
    if(dx<0&&qs.scrollLeft-310<0){qs.scrollLeft+=span;}
    if(dx>0&&qs.scrollLeft+310>2*span){qs.scrollLeft-=span;}
  }
  qs.scrollBy({left:dx,behavior:'smooth'});
}
var bl=document.querySelector('.el-qarr-l'),br=document.querySelector('.el-qarr-r');
if(bl)bl.addEventListener('click',function(){step(-310)});
if(br)br.addEventListener('click',function(){step(310)});})();

/* ---- one FAQ open at a time (both blocks) ---- */
(function(){
  var all=[].slice.call(document.querySelectorAll('details.el-acc'));
  all.forEach(function(d){
    d.addEventListener('toggle',function(){
      if(!d.open) return;
      all.forEach(function(o){
        if(o===d||!o.open) return;
        var body=o.querySelector('.el-acc-body'); if(body){body.style.height='';body.style.transition='';}
        o.classList.remove('el-open'); o.open=false;
      });
    });
  });
})();


(function(){var bar=document.getElementById('stkBar'),box=document.getElementById('witsBundles');if(!bar)return;
var hideZone=false;
function upd(){bar.classList.toggle('el-show',!hideZone&&window.scrollY>400);}
if(box&&'IntersectionObserver' in window){
  var io=new IntersectionObserver(function(en){hideZone=en[0].isIntersecting;upd();},{rootMargin:'80px 0px 80px 0px'});
  io.observe(box);
}
addEventListener('scroll',upd,{passive:true});upd();
function go(){if(box)box.scrollIntoView({behavior:'smooth'});}
bar.querySelector('.el-stk-price').addEventListener('click',go);
bar.querySelector('.el-stk-cta').addEventListener('click',go);
})();

})();
